import styled from 'styled-components';
import { DownOutlinedIcon } from 'assets/icons';

export const SDownOutlinedIcon = styled(DownOutlinedIcon)`
  flex: 'right';
  font-size: 12px;
`;
